import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, mergeProps as _mergeProps, withModifiers as _withModifiers, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50abd234"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "チェックシート管理", -1))
const _hoisted_2 = {
  key: 0,
  class: "relative-position",
  style: {"min-height":"200px"}
}
const _hoisted_3 = { class: "absolute-center" }
const _hoisted_4 = {
  key: 0,
  class: "q-mt-lg"
}
const _hoisted_5 = { id: "setting" }
const _hoisted_6 = { style: {"line-height":"1.6"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "管理画面はスマホでもお使いいただけますが、PCでの操作を推奨いたします。", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "Step 1.", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("はじめにチェックシートの設定をして下さい（そのままでもお使いいただけます）。")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "Step 2.", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("チェックシートを配布してください。配布は「配布する」より、URLやQRコードにてチェックシートのページをお知らせ下さい。")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "Step 3.", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("配布したページよりチェックを行っていただいてください。「回答結果を見る」より回答された内容を閲覧いただけます。")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 使い方についてはこちらにも記載しておりますのでご参照ください。")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://prechk.tryit.co.jp/rm01/",
  target: "_blank"
}, "[チェックシートの設定について]", -1))
const _hoisted_20 = { class: "flex justify-end" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "page-section-title",
  style: {"margin-top":"0px"}
}, "チェックシートの設定", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "checksheet-section-title" }, "基本情報", -1))
const _hoisted_23 = { class: "basic" }
const _hoisted_24 = { class: "basic-item basic-item--book-name" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item__heading" }, "チェックシート名", -1))
const _hoisted_26 = { class: "basic-item__content" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item basic-item--book-name-notice" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" チェックシート名を記入して「名前を変更」ボタンを押してください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ※チェックシート名は日付・イベント名をわかりやすく記載されることをお勧めします。 ")
  ])
], -1))
const _hoisted_28 = { class: "basic-item basic-item--sheet-start-day" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item__heading" }, "回答開始日", -1))
const _hoisted_30 = { class: "basic-item__content" }
const _hoisted_31 = { class: "basic-item basic-item--sheet-start-time" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item__heading" }, "開始時間", -1))
const _hoisted_33 = { class: "basic-item__content" }
const _hoisted_34 = { class: "basic-item basic-item--sheet-term-hour" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item__heading" }, "回答有効時間", -1))
const _hoisted_36 = { class: "basic-item__content" }
const _hoisted_37 = { class: "basic-item basic-item--sheet-limit-unit" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item__heading" }, "回答可能人数", -1))
const _hoisted_39 = { class: "basic-item__content" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item basic-item--details-notice" }, [
  /*#__PURE__*/_createElementVNode("p", null, "※回答開始日・開始時間・回答有効時間は、有料版で自由に設定が可能になります。")
], -1))
const _hoisted_41 = { class: "basic-item basic-item--book-note" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item__heading" }, "伝達事項", -1))
const _hoisted_43 = { class: "basic-item__content" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item basic-item--book-note-notice" }, [
  /*#__PURE__*/_createElementVNode("p", null, "参加者のページに記載されます。伝達事項がある場合はご記入ください。")
], -1))
const _hoisted_45 = { class: "basic-item basic-item--book-name" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item__heading" }, "回答があったらお知らせするメールアドレス", -1))
const _hoisted_47 = { class: "basic-item__content" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item basic-item--book-note-notice" }, [
  /*#__PURE__*/_createElementVNode("p", null, "入力したメールアドレスに回答完了の通知がメール送信されます。必要ない場合は、空にしてください。")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basic-item basic-item--details-notice" }, [
  /*#__PURE__*/_createElementVNode("p", null, "※メール通知機能は有料版で使用可能になります。")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "checksheet-section-title" }, "パスワードの設定", -1))
const _hoisted_51 = {
  key: 0,
  class: "column q-gutter-y-md items-stretch no-wrap q-mb-md"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  class: "q-mb-sm q-mt-none",
  style: {"font-size":"12px","color":"rgba(0, 0, 0, 0.54)"}
}
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" 現在このチェックシートの設定はパスワードで保護されています。 ")
const _hoisted_55 = {
  key: 1,
  class: "content-wrap"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, "パスワード", -1))
const _hoisted_57 = { class: "content__input" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "q-mb-sm q-mt-none",
  style: {"font-size":"11px","color":"rgba(0, 0, 0, 0.54)"}
}, " 「チェックシートの設定」や「回答結果」をパスワードで保護することができます。 ", -1))
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "column q-gutter-y-md items-stretch no-wrap q-mb-md" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  class: "q-mb-sm q-mt-none",
  style: {"font-size":"12px","color":"rgba(0, 0, 0, 0.54)"}
}
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 現在このチェックシートはパスワードで保護されています。 ")
const _hoisted_64 = { key: 1 }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "q-mb-sm q-mt-none",
  style: {"font-size":"12px","color":"rgba(0, 0, 0, 0.54)"}
}, " チェックシートの設定および回答結果はURLを知っている場合しかアクセスできませんが、さらにパスワードで保護することができます。 ", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "checksheet-section-title" }, "個人情報の要不要", -1))
const _hoisted_67 = {
  key: 2,
  class: "content-wrap"
}
const _hoisted_68 = { class: "content__label" }
const _hoisted_69 = { class: "content__input" }
const _hoisted_70 = { style: {"font-size":"13px","padding-left":"10px"} }
const _hoisted_71 = { class: "row items-center" }
const _hoisted_72 = { class: "col-4 col-sm-2" }
const _hoisted_73 = { class: "col-8 col-sm-4" }
const _hoisted_74 = { class: "row q-guttter-sm" }
const _hoisted_75 = { class: "col-12 col-sm-6" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "checksheet-section-title" }, "チェックシートの設問事項", -1))
const _hoisted_77 = {
  class: "q-mb-sm q-mt-none",
  style: {"font-size":"12px","color":"rgba(0, 0, 0, 0.54)"}
}
const _hoisted_78 = /*#__PURE__*/_createTextVNode("を押すと、設問を削除できます。 ")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("をドラッグで、設問の順番を変えられます。 ")
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 各フォーム種別の詳細についてはこちらをご覧ください。")
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://prechk.tryit.co.jp/rm02/",
  target: "_blank"
}, "[フォームの種類について]", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" （回答開始後の変更にはご注意ください。） ")
const _hoisted_84 = { class: "question" }
const _hoisted_85 = { class: "question-item" }
const _hoisted_86 = { class: "question-item__heading" }
const _hoisted_87 = { class: "question-item__handle" }
const _hoisted_88 = { class: "question-item__heading-text" }
const _hoisted_89 = { class: "question-item__content" }
const _hoisted_90 = { class: "question-item__question" }
const _hoisted_91 = { class: "question-item__type" }
const _hoisted_92 = { style: {"font-size":"0.8em"} }
const _hoisted_93 = {
  key: 0,
  class: "question-item__option"
}
const _hoisted_94 = { class: "flex q-gutter-xs no-wrap" }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = {
  key: 2,
  class: "question-item__options"
}
const _hoisted_97 = { class: "flex q-gutter-xs no-wrap" }
const _hoisted_98 = {
  key: 3,
  class: "question-item__options"
}
const _hoisted_99 = { class: "flex q-gutter-xs no-wrap" }
const _hoisted_100 = {
  key: 4,
  class: "question-item__options"
}
const _hoisted_101 = { class: "flex q-gutter-xs no-wrap" }
const _hoisted_102 = {
  key: 5,
  class: "question-item__options"
}
const _hoisted_103 = { class: "question-item__actions" }
const _hoisted_104 = {
  key: 0,
  class: "question-item__required"
}
const _hoisted_105 = { class: "question-item__remove" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "q-my-md" }, "設問を追加する場合は、以下のボタンを押してください。", -1))
const _hoisted_107 = { class: "row justify-center q-mb-lg" }
const _hoisted_108 = { class: "row justify-center" }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-section-title" }, "チェックシート配布", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"-12px"} }, "下記のいずれかの方法でチェックをしたい方に配布し、お知らせ下さい。", -1))
const _hoisted_112 = { class: "content-wrap" }
const _hoisted_113 = { class: "col-12" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, "URL共有", -1))
const _hoisted_115 = { class: "content__input" }
const _hoisted_116 = { class: "col-12 col-sm-6" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, "印刷配布用PDF", -1))
const _hoisted_118 = { class: "content__input" }
const _hoisted_119 = { class: "q-mt-md" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, "QRコード", -1))
const _hoisted_121 = { class: "text-center" }
const _hoisted_122 = ["src"]
const _hoisted_123 = { class: "col-12 col-sm-6" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, "SNSで共有", -1))
const _hoisted_125 = { class: "content__input" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, "メールで共有", -1))
const _hoisted_127 = { class: "content__input" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-negative" }, "こちらの機能は有料会員のみの機能です。", -1))
const _hoisted_129 = { class: "content__input" }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-section-title" }, "チェックシート配布", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下記のいずれかの方法でチェックをしたい方に配布し、お知らせ下さい。", -1))
const _hoisted_133 = { class: "row q-col-gutter-md" }
const _hoisted_134 = { class: "col-12" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "share-section-title" }, "URL共有", -1))
const _hoisted_136 = { class: "col-12 col-sm-6" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "share-section-title" }, "印刷配布用PDF", -1))
const _hoisted_138 = { style: {"margin-top":"23px"} }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "share-section-title" }, "QRコード", -1))
const _hoisted_140 = ["src"]
const _hoisted_141 = { class: "col-12 col-sm-6" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "share-section-title" }, "SNSで共有", -1))
const _hoisted_143 = { class: "row q-gutter-xs" }
const _hoisted_144 = { class: "q-mt-md" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "share-section-title" }, "メールで共有", -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-negative" }, "こちらの機能は有料会員のみの機能です。", -1))
const _hoisted_147 = { class: "flex q-gutter-sm justify-center q-mt-sm" }
const _hoisted_148 = { key: 1 }
const _hoisted_149 = { class: "page-section-title" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "このページはパスワードでロックされています。", -1))
const _hoisted_151 = { class: "row q-gutter-sm" }
const _hoisted_152 = { class: "col-grow" }
const _hoisted_153 = { class: "col-shrink" }
const _hoisted_154 = { class: "q-mt-md" }

import { ref } from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import { useAsyncTask } from 'vue-concurrency'
import draggable from 'vuedraggable'
import api from '@/api'
import { BookNavi } from '@/components'
import { useRemind, useLock, useQuestionSetting } from '@/composables'
import { Book } from '@/models'
import { useUserStore, useErrorStore, useBookStore } from '@/stores'
import { swalSuccess, swalError, openInNewWindow, copy, swalConfirm } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
// const router = useRouter()
const userStore = useUserStore()
const errorStore = useErrorStore()
const bookStore = useBookStore()

const bookHash = ref(route.query.cd as string)

const book = ref(new Book())

const isValid = ref(false)
const hasError = ref(false)

const publish = ref(null)

const task = useAsyncTask(async () => {
  return api.book
    .get({ cd: bookHash.value })
    .then(data => {
      // Bookデータを保持
      book.value = data
      // 設問データにIDを割り振る。
      // 古いデータだとIDが割り振られていない可能性があるため。
      // IDが割り振られているか否かなど、諸々のチェックの手間を省くため、毎回IDを振り直す。
      book.value.questions = book.value.questions.map((row, i) => ({ ...row, id: i + 1 }))
      // console.log(data.bookEMList)
      return data
    })
    .catch(errorStore?.go)
}).drop()

task.perform().then(() => {
  if (route.hash === '#publish') {
    document.getElementById('publish')?.scrollIntoView({
      behavior: 'smooth',
    })
  }
})

function save() {
  // 必須項目の検証
  validate()

  if (!hasError.value) {
    isValid.value = false
    // パスワードが設定済みのときはパスワードを空にする（サーバー側でも判定しているが念のため）
    if (hasPassword.value) {
      book.value.bookPass = ''
    }
    api.book
      .set({ ...book.value })
      .then(() => {
        swalSuccess.fire({ text: '保存しました' })
        // 新規にパスワードを設定した場合はストアへロック解除状態を記録する
        if (book.value.bookPass) {
          bookStore.unlock(book.value.bookHash)
        }
        // 最新のデータを取得して画面を書き換え
        task.perform()
      })
      .catch(err => {
        swalError.fire({ text: err })
      })
  } else {
    isValid.value = true
    swalError.fire({ text: '必須項目を入力してください' })
  }
}

// 設問の設定
const { addQuestion, deleteQuestion } = useQuestionSetting(book)

// パスワード保護
const { hasPassword, isUnlocked, lockForm, unlock } = useLock(book)

// パスワードリマインド
const { task: remindTask, remind } = useRemind(bookHash.value)

/* 共有 */
const mailList = ref('')

function shareByEmail() {
  api.book
    .shareByEmail({
      mailList: mailList.value,
      params: { cd: bookHash.value },
    })
    .then(() => {
      swalSuccess.fire({ text: 'メールを送信しました' })
    })
    .catch(err => {
      swalError.fire({ text: err })
    })
}

function shareByEmailTest() {
  api.book
    .shareByEmailTest({ cd: bookHash.value })
    .then(() => {
      swalSuccess.fire({ text: 'メールを送信しました' })
    })
    .catch(err => {
      swalError.fire({ text: err })
    })
}

function copyBook() {
  swalConfirm.fire({ text: 'このチェックシートを複製して追加します。\nよろしいですか？' }).then(result => {
    if (result.isConfirmed) {
      const bookadd = {
        userHash: userStore.hash,
        bookHash: bookHash.value,
      }
      api.mypage.createBook(bookadd).then(() => {
        swalSuccess.fire({ text: '複製しました。' })
      })
    }
  })
}
/* チェックシートを複製した際はページをリロードする */
onBeforeRouteUpdate(async (to, from) => {
  if (to.query.cd !== from.query.cd) {
    location.reload()
  }
})

// バリデーション
function validate() {
  book.value.questions.forEach(question => {
    hasError.value = question.question === '' ? true : false
    hasError.value = question.type === '' ? true : false
    if (question.type === 'r02') {
      hasError.value = question.qa === '' ? true : false
      hasError.value = question.qb === '' ? true : false
    } else if (question.type === 'r03') {
      hasError.value = question.qa === '' ? true : false
      hasError.value = question.qb === '' ? true : false
      hasError.value = question.qc === '' ? true : false
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(task).isRunning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_spinner, {
                  showing: "",
                  color: "grey",
                  size: "100px",
                  thickness: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(isUnlocked))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_unref(BookNavi), {
                      "book-hash": book.value.bookHash,
                      "sheet-hash": book.value.sheetHash,
                      style: {"margin-bottom":"33px"}
                    }, null, 8, ["book-hash", "sheet-hash"]),
                    _createElementVNode("section", _hoisted_5, [
                      _createElementVNode("div", {
                        style: _normalizeStyle(_ctx.$q.screen.lt.sm ? '' : 'padding-left: 0.7em')
                      }, [
                        _createElementVNode("p", _hoisted_6, [
                          (_ctx.$q.screen.lt.sm)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_q_icon, {
                                  name: "fa fa-info-circle",
                                  style: {"font-size":"14px","margin":"0px 2px"}
                                }),
                                _hoisted_7,
                                _hoisted_8
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_9,
                          _hoisted_10,
                          _hoisted_11,
                          _hoisted_12,
                          _hoisted_13,
                          _hoisted_14,
                          _hoisted_15,
                          _hoisted_16,
                          _hoisted_17,
                          _hoisted_18,
                          _hoisted_19
                        ])
                      ], 4),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_q_btn, {
                          style: _normalizeStyle([_ctx.$q.screen.lt.sm ? 'max-width: 357px; width: 100%; margin: 0 auto' : '', {"margin-bottom":"19px","background":"rgb(80, 107, 189)","color":"white"}]),
                          label: "このチェックシートを複製",
                          padding: "10px 18px",
                          onClick: copyBook
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              size: "1.2em",
                              style: {"margin-left":"14px"},
                              name: "far fa-copy"
                            })
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _hoisted_21,
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_q_input, {
                              dense: "",
                              outlined: "",
                              "stack-label": _ctx.$q.screen.gt.md,
                              label: _ctx.$q.screen.gt.sm ? 'チェックシート名' : undefined,
                              placeholder: "例： 2022年11月度 フットサル地区対抗戦",
                              modelValue: book.value.bookName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((book.value.bookName) = $event))
                            }, null, 8, ["stack-label", "label", "modelValue"])
                          ])
                        ]),
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_q_input, {
                              type: "date",
                              dense: "",
                              outlined: "",
                              "stack-label": _ctx.$q.screen.gt.md,
                              label: _ctx.$q.screen.gt.sm ? '回答開始日' : undefined,
                              disable: !_unref(userStore).data,
                              "input-class": "text-right",
                              modelValue: book.value.sheetStartDay,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((book.value.sheetStartDay) = $event))
                            }, null, 8, ["stack-label", "label", "disable", "modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_q_input, {
                              type: "time",
                              dense: "",
                              outlined: "",
                              "stack-label": _ctx.$q.screen.gt.md,
                              label: _ctx.$q.screen.gt.sm ? '開始時間' : undefined,
                              disable: !_unref(userStore).data,
                              "input-class": "text-right",
                              modelValue: book.value.sheetStartTime,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((book.value.sheetStartTime) = $event))
                            }, null, 8, ["stack-label", "label", "disable", "modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_q_input, {
                              type: "number",
                              dense: "",
                              outlined: "",
                              "stack-label": _ctx.$q.screen.gt.md,
                              label: _ctx.$q.screen.gt.sm ? '回答有効時間' : undefined,
                              disable: !_unref(userStore).data,
                              suffix: "時間",
                              "input-class": "text-right",
                              modelValue: book.value.sheetTermHour,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((book.value.sheetTermHour) = $event))
                            }, null, 8, ["stack-label", "label", "disable", "modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_q_input, {
                              type: "number",
                              dense: "",
                              outlined: "",
                              "stack-label": _ctx.$q.screen.gt.md,
                              label: _ctx.$q.screen.gt.sm ? '回答可能人数' : undefined,
                              disable: !_unref(userStore).data,
                              suffix: "人",
                              "input-class": "text-right",
                              modelValue: book.value.sheetLimitUnit,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((book.value.sheetLimitUnit) = $event))
                            }, null, 8, ["stack-label", "label", "disable", "modelValue"])
                          ])
                        ]),
                        _hoisted_40,
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, [
                            _createVNode(_component_q_input, {
                              type: "textarea",
                              dense: "",
                              outlined: "",
                              autogrow: "",
                              "stack-label": _ctx.$q.screen.gt.md,
                              label: _ctx.$q.screen.gt.sm ? '伝達事項' : undefined,
                              placeholder: "例： 参加者への伝達事項：当日は体温を測るのを忘れないでください。",
                              "input-style": "min-height: calc(1px + 18px * 3 + 8px)",
                              modelValue: book.value.bookNote,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((book.value.bookNote) = $event))
                            }, null, 8, ["stack-label", "label", "modelValue"])
                          ])
                        ]),
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_q_input, {
                              dense: "",
                              outlined: "",
                              "stack-label": _ctx.$q.screen.gt.md,
                              label: _ctx.$q.screen.gt.sm ? '回答があったら通知するメールアドレス' : undefined,
                              placeholder: "例： xxxxx@example.co.jp",
                              modelValue: book.value.bookEMList,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((book.value.bookEMList) = $event)),
                              autocorrect: "off",
                              autocapitalize: "off",
                              autocomplete: "off",
                              spellcheck: "false"
                            }, null, 8, ["stack-label", "label", "modelValue"])
                          ])
                        ]),
                        _hoisted_48,
                        _hoisted_49
                      ]),
                      _hoisted_50,
                      (_ctx.$q.screen.lt.sm)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            (_unref(hasPassword))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createElementVNode("p", _hoisted_53, [
                                    _hoisted_54,
                                    _createVNode(_component_q_btn, {
                                      outline: "",
                                      color: "dark",
                                      label: "パスワードをお忘れの場合はこちら",
                                      size: "md",
                                      onClick: _unref(remind),
                                      loading: _unref(remindTask).isRunning,
                                      autocomplete: "new-password"
                                    }, null, 8, ["onClick", "loading"])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                  _hoisted_56,
                                  _createElementVNode("div", _hoisted_57, [
                                    _hoisted_58,
                                    _createVNode(_component_q_input, {
                                      type: "password",
                                      dense: "",
                                      outlined: "",
                                      modelValue: book.value.bookPass,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((book.value.bookPass) = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              (_unref(hasPassword))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                    _createElementVNode("p", _hoisted_62, [
                                      _hoisted_63,
                                      _createVNode(_component_q_btn, {
                                        outline: "",
                                        color: "dark",
                                        label: "パスワードをお忘れの場合はこちら",
                                        size: "sm",
                                        onClick: _unref(remind),
                                        loading: _unref(remindTask).isRunning
                                      }, null, 8, ["onClick", "loading"])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _hoisted_65,
                                    _createVNode(_component_q_input, {
                                      type: "password",
                                      dense: "",
                                      outlined: "",
                                      "stack-label": "",
                                      label: "パスワード",
                                      modelValue: book.value.bookPass,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((book.value.bookPass) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                            ])
                          ])),
                      _hoisted_66,
                      (_ctx.$q.screen.lt.sm)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(book.value.personalAttr, (data, key) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                _createElementVNode("div", _hoisted_68, _toDisplayString(data.name), 1),
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_q_checkbox, {
                                        style: {"width":"100%"},
                                        label: "項目を表示する",
                                        modelValue: data.display,
                                        "onUpdate:modelValue": ($event: any) => ((data.display) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_q_checkbox, {
                                        style: {"width":"100%"},
                                        label: "必須にする",
                                        modelValue: data.required,
                                        "onUpdate:modelValue": ($event: any) => ((data.required) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_70, _toDisplayString(data.note), 1)
                                ])
                              ], 64))
                            }), 128))
                          ]))
                        : (_openBlock(), _createBlock(_component_q_card, {
                            key: 3,
                            bordered: "",
                            flat: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(book.value.personalAttr, (data, key, i) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                  (i !== 0)
                                    ? (_openBlock(), _createBlock(_component_q_separator, { key: 0 }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_q_card_section, { class: "q-pa-sm" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_71, [
                                        _createElementVNode("div", _hoisted_72, _toDisplayString(data.name), 1),
                                        _createElementVNode("div", _hoisted_73, [
                                          _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("div", null, [
                                              _createVNode(_component_q_checkbox, {
                                                label: "項目を表示する",
                                                modelValue: data.display,
                                                "onUpdate:modelValue": ($event: any) => ((data.display) = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _createElementVNode("div", null, [
                                              _createVNode(_component_q_checkbox, {
                                                label: "必須にする",
                                                modelValue: data.required,
                                                "onUpdate:modelValue": ($event: any) => ((data.required) = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_75, _toDisplayString(data.note), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 64))
                              }), 128))
                            ]),
                            _: 1
                          })),
                      _hoisted_76,
                      _createElementVNode("p", _hoisted_77, [
                        _createVNode(_component_q_icon, {
                          name: "fas fa-trash",
                          style: {"font-size":"14px","margin":"0px 2px"}
                        }),
                        _hoisted_78,
                        _createVNode(_component_q_icon, {
                          name: "fas fa-grip-vertical",
                          style: {"font-size":"14px","margin":"0px 2px"}
                        }),
                        _hoisted_79,
                        _createVNode(_component_q_icon, {
                          name: "fa fa-info-circle",
                          style: {"font-size":"14px","margin":"0px 2px"}
                        }),
                        _hoisted_80,
                        _hoisted_81,
                        _hoisted_82,
                        _hoisted_83
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_84, [
                          _createVNode(_unref(draggable), {
                            tag: "transition-group",
                            "component-data": { name: 'fade' },
                            modelValue: book.value.questions,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((book.value.questions) = $event)),
                            "item-key": "id",
                            animation: "200",
                            "ghost-class": "ghost",
                            disabled: false,
                            group: "question",
                            handle: "[data-handle]"
                          }, {
                            item: _withCtx(({ element: question, index }) => [
                              _createElementVNode("div", _hoisted_85, [
                                _createElementVNode("div", _hoisted_86, [
                                  _createElementVNode("div", _hoisted_87, [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      icon: "fas fa-grip-vertical",
                                      color: "grey",
                                      size: "sm",
                                      "data-handle": "",
                                      style: {"cursor":"grab"}
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_88, "設問 " + _toDisplayString(index + 1), 1)
                                ]),
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _createVNode(_component_q_input, {
                                      dense: "",
                                      outlined: "",
                                      "stack-label": "",
                                      label: "設問内容",
                                      modelValue: question.question,
                                      "onUpdate:modelValue": ($event: any) => ((question.question) = $event),
                                      error: question.question === '' && isValid.value,
                                      "error-message": "設問内容は必須です",
                                      "hide-bottom-space": ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "error"])
                                  ]),
                                  _createElementVNode("div", _hoisted_91, [
                                    _createVNode(_component_q_select, {
                                      dense: "",
                                      outlined: "",
                                      "map-options": "",
                                      "emit-value": "",
                                      "stack-label": "",
                                      label: "種別",
                                      options: [
                              { label: '題名', value: 'lbl' },
                              { label: '２択', value: 'r02' },
                              { label: '３択', value: 'r03' },
                              { label: '５択', value: 'r05' },
                              { label: '温度', value: 'tmp' },
                              { label: '数字', value: 'num' },
                              { label: '文章', value: 'txt' },
                              { label: '年月日', value: 'dt3' },
                              { label: '時分', value: 'tm2' },
                              { label: '長文', value: 'txb' },
                              { label: '年月日～年月日', value: 'ftd' },
                              { label: '時分～時分', value: 'ftt' },
                              { label: '数値～数値', value: 'ftn' },
                              { label: 'ラジオボタン', value: 'r0n' },
                              { label: 'チェックボックス', value: 'ckb' },
                              { label: 'セレクト', value: 'slb' },
                            ],
                                      modelValue: question.type,
                                      "onUpdate:modelValue": ($event: any) => ((question.type) = $event),
                                      error: question.type === '' && isValid.value,
                                      "error-message": "種別は必須です",
                                      "hide-bottom-space": ""
                                    }, {
                                      "selected-item": _withCtx((scope) => [
                                        _createElementVNode("span", _hoisted_92, _toDisplayString(scope.opt.label), 1)
                                      ]),
                                      option: _withCtx((scope) => [
                                        _createVNode(_component_q_item, _mergeProps(scope.itemProps, { dense: "" }), {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_item_label, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1040)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "error"])
                                  ]),
                                  (question.type === 'tmp' || question.type === 'num' || question.type === 'ftn')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                        _createElementVNode("div", _hoisted_94, [
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "prefix",
                                            modelValue: question.prefix,
                                            "onUpdate:modelValue": ($event: any) => ((question.prefix) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "suffix",
                                            modelValue: question.suffix,
                                            "onUpdate:modelValue": ($event: any) => ((question.suffix) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (question.type === 'txt' || question.type === 'txb')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                        _createVNode(_component_q_input, {
                                          dense: "",
                                          outlined: "",
                                          "stack-label": "",
                                          label: "記入例",
                                          modelValue: question.placeholder,
                                          "onUpdate:modelValue": ($event: any) => ((question.placeholder) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (question.type === 'r02')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                        _createElementVNode("div", _hoisted_97, [
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "選択肢１",
                                            placeholder: "例： はい",
                                            modelValue: question.qa,
                                            "onUpdate:modelValue": ($event: any) => ((question.qa) = $event),
                                            error: question.qa === '' && isValid.value,
                                            "error-message": "選択肢は必須です",
                                            "hide-bottom-space": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error"]),
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "選択肢２",
                                            placeholder: "例： いいえ",
                                            modelValue: question.qb,
                                            "onUpdate:modelValue": ($event: any) => ((question.qb) = $event),
                                            error: question.qb === '' && isValid.value,
                                            "error-message": "選択肢は必須です",
                                            "hide-bottom-space": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (question.type === 'r03')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                        _createElementVNode("div", _hoisted_99, [
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "選択肢１",
                                            placeholder: "例： はい",
                                            modelValue: question.qa,
                                            "onUpdate:modelValue": ($event: any) => ((question.qa) = $event),
                                            error: question.qa === '' && isValid.value,
                                            "error-message": "必須です",
                                            "hide-bottom-space": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error"]),
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "選択肢２",
                                            placeholder: "例： いいえ",
                                            modelValue: question.qb,
                                            "onUpdate:modelValue": ($event: any) => ((question.qb) = $event),
                                            error: question.qb === '' && isValid.value,
                                            "error-message": "必須です",
                                            "hide-bottom-space": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error"]),
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "選択肢３",
                                            placeholder: "例： どちらでもない",
                                            modelValue: question.qc,
                                            "onUpdate:modelValue": ($event: any) => ((question.qc) = $event),
                                            error: question.qc === '' && isValid.value,
                                            "error-message": "必須です",
                                            "hide-bottom-space": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (question.type === 'r05')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                        _createElementVNode("div", _hoisted_101, [
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "低評価",
                                            placeholder: "良くない",
                                            modelValue: question.qa,
                                            "onUpdate:modelValue": ($event: any) => ((question.qa) = $event),
                                            error: question.qa === '' && isValid.value,
                                            "error-message": "低評価は必須です",
                                            "hide-bottom-space": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error"]),
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            "stack-label": "",
                                            label: "高評価",
                                            placeholder: "良い",
                                            modelValue: question.qb,
                                            "onUpdate:modelValue": ($event: any) => ((question.qb) = $event),
                                            error: question.qb === '' && isValid.value,
                                            "error-message": "高評価は必須です",
                                            "hide-bottom-space": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (question.type === 'r0n' || question.type === 'ckb' || question.type === 'slb')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                        _createVNode(_component_q_input, {
                                          dense: "",
                                          outlined: "",
                                          "stack-label": "",
                                          label: "選択肢（文字列を半角カンマ区切り）",
                                          modelValue: question.qa,
                                          "onUpdate:modelValue": ($event: any) => ((question.qa) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_103, [
                                    (question.type !== 'lbl')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                          _createVNode(_component_q_checkbox, {
                                            dense: "",
                                            label: "必須にする",
                                            modelValue: question.required,
                                            "onUpdate:modelValue": ($event: any) => ((question.required) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_105, [
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        round: "",
                                        icon: "fas fa-trash",
                                        color: "grey",
                                        size: "sm",
                                        onClick: ($event: any) => (_unref(deleteQuestion)(index))
                                      }, null, 8, ["onClick"])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _hoisted_106,
                        _createElementVNode("div", _hoisted_107, [
                          _createVNode(_component_q_btn, {
                            round: "",
                            outline: "",
                            color: "dark",
                            icon: "add",
                            onClick: _unref(addQuestion)
                          }, null, 8, ["onClick"])
                        ]),
                        _createElementVNode("p", _hoisted_108, [
                          _createVNode(_component_q_btn, {
                            unelevated: "",
                            type: "submit",
                            color: "primary",
                            label: "保存する",
                            onClick: save
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("section", {
                      id: "publish",
                      ref: (_value, _refs) => {
                        _refs['publish'] = _value
                        publish.value = _value
                      }
                    }, [
                      (_ctx.$q.screen.lt.sm)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                            _hoisted_110,
                            _hoisted_111,
                            _createElementVNode("div", _hoisted_112, [
                              _createElementVNode("div", _hoisted_113, [
                                _hoisted_114,
                                _createElementVNode("div", _hoisted_115, [
                                  _createVNode(_component_q_input, {
                                    outlined: "",
                                    dense: "",
                                    "model-value": book.value.url.page
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        round: "",
                                        flat: "",
                                        color: "dark",
                                        icon: "content_copy",
                                        label: "COPY",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(copy)(book.value.url.page)))
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["model-value"]),
                                  _createVNode(_component_q_btn, {
                                    class: "q-mt-sm",
                                    outline: "",
                                    color: "dark",
                                    "icon-right": "open_in_new",
                                    label: "チェックシートを見る",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(openInNewWindow)(book.value.url.page))),
                                    style: {"min-width":"241px"}
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_116, [
                                _createElementVNode("div", null, [
                                  _hoisted_117,
                                  _createElementVNode("div", _hoisted_118, [
                                    _createVNode(_component_q_btn, {
                                      outline: "",
                                      color: "dark",
                                      icon: "fas fa-file-pdf",
                                      "icon-right": "open_in_new",
                                      label: "印刷配布用PDFを開く",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(openInNewWindow)(book.value.url.pdf)))
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_119, [
                                  _hoisted_120,
                                  _createElementVNode("div", _hoisted_121, [
                                    _createElementVNode("img", {
                                      src: book.value.url.qrcode,
                                      width: "200",
                                      height: "200"
                                    }, null, 8, _hoisted_122)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("div", null, [
                                  _hoisted_124,
                                  _createElementVNode("div", _hoisted_125, [
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      round: "",
                                      type: "a",
                                      href: `https://twitter.com/share?url=${book.value.url.twitter}&text=「${book.value.bookName}」にお答えください`,
                                      target: "_blank",
                                      icon: "fab fa-twitter",
                                      color: "twitter",
                                      class: "q-mr-xs"
                                    }, null, 8, ["href"]),
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      round: "",
                                      type: "a",
                                      href: `https://www.facebook.com/sharer.php?quote=「${book.value.bookName}」にお答えください&u=${book.value.url.facebook}`,
                                      target: "_blank",
                                      icon: "fab fa-facebook-f",
                                      color: "facebook",
                                      class: "q-mr-xs"
                                    }, null, 8, ["href"]),
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      round: "",
                                      type: "a",
                                      href: `https://social-plugins.line.me/lineit/share?url=${book.value.url.line}`,
                                      target: "_blank",
                                      icon: "fab fa-line",
                                      color: "line"
                                    }, null, 8, ["href"])
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_126,
                                  _createElementVNode("div", _hoisted_127, [
                                    _hoisted_128,
                                    _createElementVNode("p", null, "メールアドレスのリストを張り付けて送信 ※" + _toDisplayString(book.value.sheetLimitUnit) + "名まで可", 1),
                                    _createVNode(_component_q_input, {
                                      type: "textarea",
                                      autogrow: "",
                                      outlined: "",
                                      dense: "",
                                      "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                                      modelValue: mailList.value,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((mailList).value = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_129, [
                                    _createVNode(_component_q_btn, {
                                      outline: "",
                                      color: "rimary",
                                      label: "自分にテスト送信",
                                      class: "btn btn-outline-primary",
                                      onClick: shareByEmailTest,
                                      style: {"width":"calc(50% - 2.5px)","margin-right":"5px"}
                                    }),
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      color: "primary",
                                      label: "一括送信",
                                      class: "btn btn-primary",
                                      onClick: shareByEmail,
                                      style: {"width":"calc(50% - 2.5px)"}
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_130, [
                            _hoisted_131,
                            _hoisted_132,
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("div", _hoisted_134, [
                                _hoisted_135,
                                _createVNode(_component_q_input, {
                                  outlined: "",
                                  dense: "",
                                  "model-value": book.value.url.page
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      outline: "",
                                      round: "",
                                      flat: "",
                                      color: "dark",
                                      icon: "content_copy",
                                      label: "COPY",
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(copy)(book.value.url.page)))
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["model-value"]),
                                _createVNode(_component_q_btn, {
                                  class: "q-mt-sm",
                                  outline: "",
                                  color: "dark",
                                  "icon-right": "open_in_new",
                                  label: "チェックシートを見る",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(openInNewWindow)(book.value.url.page))),
                                  style: {"min-width":"241px"}
                                })
                              ]),
                              _createElementVNode("div", _hoisted_136, [
                                _createElementVNode("div", null, [
                                  _hoisted_137,
                                  _createVNode(_component_q_btn, {
                                    outline: "",
                                    color: "dark",
                                    icon: "fas fa-file-pdf",
                                    "icon-right": "open_in_new",
                                    label: "印刷配布用PDFを開く",
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(openInNewWindow)(book.value.url.pdf)))
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_138, [
                                  _hoisted_139,
                                  _createElementVNode("img", {
                                    src: book.value.url.qrcode,
                                    width: "200",
                                    height: "200"
                                  }, null, 8, _hoisted_140)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("div", null, [
                                  _hoisted_142,
                                  _createElementVNode("div", _hoisted_143, [
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      round: "",
                                      type: "a",
                                      href: `https://twitter.com/share?url=${book.value.url.twitter}&text=チェックシート - ${book.value.bookName} - にお答えください`,
                                      target: "_blank",
                                      icon: "fab fa-twitter",
                                      color: "twitter"
                                    }, null, 8, ["href"]),
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      round: "",
                                      type: "a",
                                      href: `https://www.facebook.com/sharer.php?quote=チェックシート - ${book.value.bookName} - にお答えください&u=${book.value.url.facebook}`,
                                      target: "_blank",
                                      icon: "fab fa-facebook-f",
                                      color: "facebook"
                                    }, null, 8, ["href"]),
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      round: "",
                                      type: "a",
                                      href: `https://social-plugins.line.me/lineit/share?url=${book.value.url.line}`,
                                      target: "_blank",
                                      icon: "fab fa-line",
                                      color: "line"
                                    }, null, 8, ["href"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_144, [
                                  _hoisted_145,
                                  _hoisted_146,
                                  _createElementVNode("p", null, "メールアドレスのリストを張り付けて送信 ※" + _toDisplayString(book.value.sheetLimitUnit) + "名まで可", 1),
                                  _createVNode(_component_q_input, {
                                    type: "textarea",
                                    autogrow: "",
                                    outlined: "",
                                    dense: "",
                                    "input-style": "min-height: calc(9px + 18px * 3 + 6px)",
                                    modelValue: mailList.value,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((mailList).value = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_147, [
                                    _createVNode(_component_q_btn, {
                                      outline: "",
                                      color: "rimary",
                                      label: "自分にテスト送信",
                                      class: "btn btn-outline-primary",
                                      onClick: shareByEmailTest
                                    }),
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      color: "primary",
                                      label: "一括送信",
                                      class: "btn btn-primary",
                                      onClick: shareByEmail
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ], 512)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_148, [
                    _createElementVNode("h2", _hoisted_149, _toDisplayString(book.value.bookName), 1),
                    _hoisted_150,
                    _createElementVNode("form", {
                      onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_unref(unlock) && _unref(unlock)(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, [
                          _createVNode(_component_q_input, {
                            type: "password",
                            dense: "",
                            outlined: "",
                            "stack-label": "",
                            label: "パスワード",
                            modelValue: _unref(lockForm).password,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(lockForm).password) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_153, [
                          _createVNode(_component_q_btn, {
                            unelevated: "",
                            type: "submit",
                            color: "primary",
                            label: "ロックを解除する"
                          })
                        ])
                      ])
                    ], 32),
                    _createElementVNode("div", _hoisted_154, [
                      _createVNode(_component_q_btn, {
                        outline: "",
                        color: "dark",
                        label: "パスワードをお忘れの場合はこちら",
                        onClick: _unref(remind),
                        loading: _unref(remindTask).isRunning
                      }, null, 8, ["onClick", "loading"])
                    ])
                  ]))
            ], 64))
      ]),
      _: 1
    })
  ]))
}
}

})